import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { Invoices } from '~pages/payments/invoices';

const invoicesSearchSchema = z.object({
  /** Comma-separated statuses e.g. "upcoming,scheduled" for preset filters */
  statuses: z.string().optional(),
});

export const Route = createFileRoute('/_auth/_layout/payment/invoices')({
  validateSearch: zodValidator(invoicesSearchSchema),
  component: Invoices,
});
